import { render, staticRenderFns } from "./RoleSelectDialog.vue?vue&type=template&id=1f6e8ad6&scoped=true"
import script from "./RoleSelectDialog.vue?vue&type=script&lang=js"
export * from "./RoleSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleSelectDialog.vue?vue&type=style&index=0&id=1f6e8ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e8ad6",
  null
  
)

export default component.exports